customElements.define("sticky-component", class extends HTMLElement {
    connectedCallback(){

      this.stickyPoint = document.querySelector(this.dataset.stickyPoint) || null;
  
      if(!this.stickyPoint) return;

      window.addEventListener("load", ()=>{
        this.lastScroll = window.__earlyScrollY + 6;
        this.findPosition();
        // Set min-height after load when content is rendered
        this.updateMinHeight();
      })
  
      window.addEventListener("scroll", e=>{
        // console.log('scroll')
        this.findPosition();
      })
  
      // Also set min-height initially (may be 0 if async, will be updated on load)
      this.updateMinHeight();
  
      window.addEventListener('resize', ()=>{
        this.updateMinHeight();
      })
    }
  
    findPosition(){
      const {scrollY: windowTop} = window;
      const targetTop = this.stickyPoint.getBoundingClientRect().top + document.documentElement.scrollTop
      //console.log('this.lastScroll', this.lastScroll)
      //console.log('windowTop', windowTop)
      //console.log('targetTop', targetTop) 
      if(windowTop > targetTop && this.lastScroll <= targetTop){
        this.toggleWidget = true;
      }
      else if(windowTop < targetTop && this.lastScroll >= targetTop){
        this.toggleWidget = false;
      }
  
      this.lastScroll = windowTop;
    }
  
    set toggleWidget(boolean){
      boolean ? this.show() : this.close();
    }

    updateMinHeight(){
      const height = this.scrollHeight || this.offsetHeight || 0;
      if(height > 0) {
        this.style.setProperty('--min-height', height + 'px');
      }
    }
  
    show(){
      //this.detectOtherSticky();
      this.classList.add('active');
      this.dataset.bodyClass && document.body.classList.add(this.dataset.bodyClass);
    }
  
    close(){
      this.classList.remove('active');
      this.dataset.bodyClass && document.body.classList.remove(this.dataset.bodyClass);
    }
  
    detectOtherSticky(){
      const { inViewPort } = theme;
  
      const array = [];
      document.querySelectorAll('sticky-component').forEach(item=>{
        if(item != this){
          item.getStickyEl && array.push(item.getStickyEl);
        }
      });
  
  
      const headerSticky = document.querySelector('sticky-header');
      headerSticky && array.push(headerSticky);
  
      // this.bottom = 0;
  
      array.forEach(item=>{
        inViewPort(item, ()=>{
          const {bottom} = item.getBoundingClientRect();
          
          // this.bottom += bottom;
  
          // this.style.setProperty('--top', this.bottom+'px');
        }, true)
      })
    }
  
    get getStickyEl(){
      if(this.classList.contains('jsStickyEl'))
        return this;
  
      return this.querySelector('.jsStickyEl') || null;
    }
  });